import AiTestView from "../views/AiTestView.vue";
import AiChatView from "../views/AiChatView.vue";
import AiWidgetView from "../views/AiWidgetView.vue";

export default [
  {
    path: "/ai-test",
    name: "ai-test",
    component: AiTestView,
  },
  {
    path: "/ai-test/chat",
    name: "ai-test-chat",
    component: AiChatView,
  },
  {
    path: "/ai-test/widget",
    name: "ai-test-widget",
    component: AiWidgetView,
  },
];
